import axios from 'axios'
import request from '@/utils/request'

// 富文本(如同業交流文章內文)送出前的 UTF-8 安全 base64 編碼，並加 "b64:" 顯式前綴。
// 目的：避免 AWS WAF 將富文本 HTML 誤判為 XSS 攻擊而回 403。後端 Base64ContentCodec 僅在看到前綴時解碼，
// 否則視為明文原樣處理(消除「明文剛好也是合法 base64」被誤解成亂碼的資料損毀風險)。空字串/null 原樣回傳。
export const CONTENT_BASE64_PREFIX = 'b64:'
export function encodeContentBase64(str) {
  if (!str) return str
  const bytes = new TextEncoder().encode(str)
  let binary = ''
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return CONTENT_BASE64_PREFIX + btoa(binary)
}

export function addDays(date, days) {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export function dateTo10CharString(d) {
  let options = {
    timeZone: 'Asia/Taipei',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }

  return `${new Date(d).toLocaleString('zh-TW', options).replace(/\//g, '-').substring(0, 10)}`
}

export function getTaiwanCurrentTime() {
  let options = {
    timeZone: 'Asia/Taipei',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }

  let twNow = new Date()
    .toLocaleString('zh-TW', options)
    // .replace('上午', ".AM.")
    // .replace('下午', ".PM.")
    .replace(/\//g, '-')
  // console.log(twNow.substring(0, 10));
  return twNow
}

export function htmlEncode(html) {
  var temp = document.createElement('div')
  temp.textContent != null ? (temp.textContent = html) : (temp.innerText = html)
  var output = temp.innerHTML
  temp = null
  return output
}

export function htmlDecode(text) {
  var temp = document.createElement('div')
  temp.innerHTML = text
  var output = temp.innerText || temp.textContent
  temp = null
  return output
}

export function buildFormData(formData, data, parentKey) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
    })
  } else {
    const value = data == null ? '' : data

    formData.append(parentKey, value)
  }
}

export function jsonToFormData(data) {
  const formData = new FormData()

  buildFormData(formData, data)

  return formData
}

export function getBase64(file) {
  var reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = function () {
    // console.log(reader.result);
  }
  reader.onerror = function (error) {
    // console.log('Error: ', error);
  }
  return reader.result
}

export function convertFileToBase64(file) {
  return new Promise((resolve, reject) => {
    // 建立FileReader物件
    const reader = new FileReader()
    // 註冊onload事件，取得result則resolve (會是一個Base64字串)
    reader.onload = () => {
      resolve(reader.result.replace('data:', '').replace(/^.+,/, ''))
    }
    // 註冊onerror事件，若發生error則reject
    reader.onerror = () => {
      reject(reader.error)
    }
    // 讀取檔案
    reader.readAsDataURL(file)
  })
}

export function _uuid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

async function checkFileType(id) {
  const url = `${process.env.VUE_APP_BASE_API}/File/getFileType/${id}`

  const response = await request({
    url: url,
    method: 'get',
    params: id,
  })
  return response.data
}

// 指定名稱下載檔案
export async function downloadAs(id, name) {
  const fileType = await checkFileType(id)
  // 檔案下載，檔案若放在CDN 避免cors問題造成無法呼叫端直接下載，於後端先把檔案載回，再傳回呼叫端。
  let notPreview = ['.jpg', '.jpge', '.png', '.bmp', '.gif', '.pdf']
  let extension = fileType.extension
  if (fileType && fileType.type == 'url' && extension && !notPreview.includes(extension)) {
    // AWS檔案網址 7/10改檔案弱勢url cdn連結，原本直接點擊改為後端下載後傳回。因有cors問題無法直接下載。7/14 測試正常繼續使用。
    const a = document.createElement('a')
    const url = fileType.url
    a.href = url
    a.setAttribute('target', '_blank')
    a.download = name
    a.click()
  } else {
    // server檔案資料檔
    const url = `${process.env.VUE_APP_BASE_API}/File/${id}`
    try {
      let response = await request({
        url: url,
        method: 'get',
        params: id,
        headers: {
          'Content-Type': 'application/octet-stream',
        },
        responseType: 'blob',
      })

      const a = document.createElement('a')
      const u = window.URL.createObjectURL(response)
      a.href = u
      a.download = name
      a.click()
    } catch (error) {
      console.log('error', error)
    }
  }

  // axios.get(url, {
  //     headers: {
  //         "Content-Type": "application/octet-stream"
  //     },
  //     responseType: "blob"
  // })
  //     .then(response => {
  //         const a = document.createElement("a");
  //         const url = window.URL.createObjectURL(response.data);
  //         a.href = url;
  //         a.download = name;
  //         a.click();
  //     })
  //     .catch(err => {
  //         console.log("error", err);
  //     });
}

export function passwords(pasLen) {
  var pasArr = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '_',
    '-',
    '$',
    '%',
    '&',
    '@',
    '+',
    '!',
  ]
  var password = ''
  var pasArrLen = pasArr.length
  for (var i = 0; i < pasLen; i++) {
    var x = Math.floor(Math.random() * pasArrLen)
    password += pasArr[x]
  }
  console.log(password)
}

export function htmlToBase64(str) {
  if (!str) return ''
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode('0x' + p1)
    })
  )
}

export function base64ToHtml(str) {
  if (!str) return ''
  try {
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(c => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )
  } catch (e) {
    return str
  }
}
